import React from "react";
import {
  ArcDroneMarker,
  ArcPolyline,
} from "@src/core/controllers";
import { arcHistoryOrderPath } from "@src/core/extensions";
import { OrderMissionEntity } from "@src/features/order/entities";
import { Marker } from "@react-google-maps/api";
import destionation from '@src/assets/destination.svg';

interface CompletedMapProps {
  order: OrderMissionEntity;
}

const CompletedMap: React.FC<CompletedMapProps> = (props) => {
  const { order } = props;

  if (!order) return null;

  return (
    <React.Fragment>
      <ArcPolyline.default path={arcHistoryOrderPath(order)} />

      {(order as any).deliveryLocation && (
        <Marker 
          draggable={false}
          position={{ lat: Number((order as any).deliveryLocation.latitude), lng: Number((order as any).deliveryLocation.longitude) }} 
          icon={{ 
            url: destionation,  
            scaledSize: new window.google.maps.Size(100, 50),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(17, 44),  
          }} />
      )}

      {order.drone && order.drone.latitude && order.drone.longitude && (
        <ArcDroneMarker.idle
          position={{
            lat: Number(order.drone.latitude),
            lng: Number(order.drone.longitude),
          }}
        />
      )}
    </React.Fragment>
  );
};

export default CompletedMap;
